// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__YZLBC","footer":"styles_footer__1EBVV"};